module.exports = __webpack_public_path__ + "email-dark--a4560d42.png";


//////////////////
// WEBPACK FOOTER
// ./_source/img/icons/email-dark.png
// module id = 27
// module chunks = 0